/*
 * @Author: your name
 * @Date: 2020-07-23 16:20:22
 * @LastEditTime: 2021-01-21 11:04:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import '@babel/polyfill'
import router from './router'
import './vender/cube-ui'
import './assets/scss/index.scss'
import './vender/x-lib-ui-h5'
import './vender/plugin'
import AssetsLoader from './assets-loader'
import { loadApis } from './api'
import i18n from '@/locale/index'
import store from './store'
import {
  SET_TOKEN,
  SET_COMMENT_PLUGIN
} from '@/store/auth.store.js'

import '@/router/theme.guard.js'
import '@/router/wechat.guard.js'
import '@/router/wecom.guard.js'
import '@/router/auth.guard.js'
import { RuleEngine, SimpleRuleEngine, functions } from '@x-apaas/x-lib-rule-engine'
import ExtensionUtil from './util/extension.util'
import '@/vender/third-sdk/amap-sdk.js'

loadApis()
AssetsLoader.requireAllSvg()
Vue.config.productionTip = false
Vue.prototype.$store = store

// 注册规则函数列表
RuleEngine.getInstance().registerContextMethods(functions)
SimpleRuleEngine.getInstance().registerContextMethods(functions)

Vue.addInterceptorsRequest('REQUEST_PARAMS_INTERCEPTOR', (e) => {
  const authStore = store.state.authModule
  const tenantStore = store.state.tenantModule
  const sharePayload = store.state.publicFormModule.sharePayload

  e.headers['xdaptimestamp'] = new Date().getTime()
  if (authStore.token) e.headers['xdaptoken'] = authStore.token
  if (tenantStore.currentOrg && tenantStore.currentOrg.id) {
    e.headers['xdaptenantid'] = tenantStore.currentOrg.id
  }
  if (tenantStore.xdaptenantversion) {
    e.headers['xdaptenantversion'] = tenantStore.xdaptenantversion
  }
  if (tenantStore.xdapplatform) {
    e.headers['xdapplatform'] = tenantStore.xdapplatform
  }
  if (sharePayload) {
    Object.assign(e.headers, sharePayload.headers)
    if (sharePayload.urlPrefix) e.url = sharePayload.urlPrefix + e.url
  }
  return e
})

// Vue.addInterceptorsRequest('REQUEST_LOADING_INTERCEPTORE', (e) => {
//   if (e.loading) {
//     Vue.prototype.$loading.show()
//   }
//   return e
// })

// Vue.addInterceptorsResponse('RESPONSE_LOADING_INTERCEPTORE', (e) => {
//   if (e && e.config.loading) {
//     Vue.prototype.$loading.hide()
//   }
//   return e
// })

// 添加response拦截器
Vue.addInterceptorsResponse('RESPONSE_SUCCESS_MSG_INTERCEPTOR', (e) => {
  const token = e && e.headers && e.headers.xdaptoken
  if (token) {
    store.commit(`authModule/${SET_TOKEN}`, token)
  }
  if (e && e.status === 200 && e.data.code === 'ok' && !e.config.disableSuccessMsg) {
    Vue.prototype.$message({
      message: e.data.message,
      type: 'success'
    })
  }
  const xDapPlugin = e && e.headers && e.headers.xdapplugin
  store.commit(`authModule/${SET_COMMENT_PLUGIN}`, ExtensionUtil.existPlugin(xDapPlugin, 'PLUGIN_COMMENT'))
  return e
})

new Vue({
  i18n,
  router,
  store,
  created() {
    const MESSAGE_TYPES = {
      'info': 'txt',
      'success': 'correct',
      'warning': 'warn',
      'error': 'error'
    }
    Vue.prototype.$message = ({ message, type = 'info', mask = false, maskClosable = false }) => {
      let toast
      if (type === 'info') {
        toast = this.$createToast({
          txt: message,
          type: MESSAGE_TYPES[type],
          time: 0,
          mask: true,
          maskClosable: true
        })
      } else {
        toast = this.$createToast({
          txt: message,
          type: MESSAGE_TYPES[type],
          mask: mask,
          maskClosable: maskClosable
        })
      }

      toast.show()
    }

    Vue.prototype.$confirm = ({ message, okConfig, cancelConfig, maskClosable }) => {
      this.$createDialog({
        type: 'confirm',
        content: message,
        maskClosable: maskClosable || false,
        confirmBtn: {
          text: (okConfig && okConfig.title) || '确定',
          active: true,
          disabled: (okConfig && okConfig.disabled) || false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: (cancelConfig && cancelConfig.title) || '取消',
          active: true,
          disabled: (cancelConfig && cancelConfig.disabled) || false,
          href: 'javascript:;'
        },
        onConfirm: okConfig && okConfig.onOk,
        onCancel: cancelConfig && cancelConfig.onCancel
      }).show()
    }
  },
  render: (h) => h(App)
}).$mount('#app')
